import {
  Box,
  Container,
  Heading,
  Text,
  HStack,
  Avatar,
  Icon,
  Flex,
} from "@chakra-ui/react";
import { FaStar, FaGoogle } from "react-icons/fa";

// Aggregate store info (use in header/SEO/components)
export const storeInfo = {
  name: "Pentagon Store",
  address:
    "16/1/P, near ESDS circle, MIDC, Satpur Colony, Nashik, Maharashtra 422007, India",
  rating: 4.8,
  reviewCount: 26,
  phone: "+91-7378511300",
  hours: "Mon–Sat 09:00–20:00",
};

// Testimonials array (converted from Google reviews)
export const testimonials = [
  {
    name: "Neeraj Bhandare",
    text: "One stop solution for all hardware needs, most premium store in Nashik with hands on demo for various products under one roof. Loved the helpfulness of the staff.",
    date: "1 month ago",
    rating: 5,
    avatar: "N",
  },
  {
    name: "Rohit Shinde",
    text: "Great Service and quality products. The staff is helpful and knowledgeable. Highly recommended.",
    date: "1 month ago",
    rating: 5,
    avatar: "R",
  },
  {
    name: "Kunal Kapse",
    text: "Genuine products at best rates. Excellent service. Well known staff. 👌🏻👌🏻👌🏻",
    date: "1 month ago",
    rating: 5,
    avatar: "K",
  },
  {
    name: "Suniel Ramchandani",
    text: "Great Experience, live demonstration of the steam generator was given, details explained, queries cleared. Will be eager to visit again.",
    date: "1 month ago",
    rating: 5,
    avatar: "S",
  },
  {
    name: "Vinod Verma",
    text: "One stop shop for quality products at reasonable prices.",
    date: "2 months ago",
    rating: 5,
    avatar: "V",
  },
  {
    name: "Vishal Patil",
    text: "Amazing shop to shopping hardware material.",
    date: "1 month ago",
    rating: 5,
    avatar: "V",
  },
  {
    name: "Rajendra Borse",
    text: "Renovation work going on at place ... As per sales agent there will all Live display of Home decor ... live kitchen …More",
    date: "1 year ago",
    rating: 4,
    avatar: "R",
  },
  {
    name: "Somnath Wagh",
    text: "Advance plumbing technology products in one roop.",
    date: "3 months ago",
    rating: 4,
    avatar: "S",
  },
  {
    name: "Ganesh Suryawanshi",
    text: "New branch open in MIDC satpur Nashik very nice collection in hardware, one of the most preferred hardware since last 20 years.",
    date: "3 years ago",
    rating: 5,
    avatar: "G",
  },
  {
    name: "Suniket Kurhade",
    text: "One stop shop, you can get everything. However employee are bit slow.",
    date: "3 years ago",
    rating: 4,
    avatar: "S",
  },
  {
    name: "Kalpana Birhade",
    text: "Most updated hardware shop and helpful people.",
    date: "2 years ago",
    rating: 5,
    avatar: "K",
  },
  {
    name: "Somanath Nandurdikar",
    text: "Find quality and branded appliances.",
    date: "2 years ago",
    rating: 5,
    avatar: "S",
  },
  {
    name: "Aniket Ghodke",
    text: "Great staff.",
    date: "3 years ago",
    rating: 5,
    avatar: "A",
  },
  {
    name: "Jignesh Goda",
    text: "Huge as name says!!!",
    date: "3 years ago",
    rating: 5,
    avatar: "J",
  },
  {
    name: "Harshal Jagtap",
    text: "Best service.",
    date: "3 years ago",
    rating: 5,
    avatar: "H",
  },
  {
    name: "Mayur Nikam",
    text: "Nice service.",
    date: "4 years ago",
    rating: 4,
    avatar: "M",
  },
  {
    name: "Akshay Ninawe",
    text: "New (recent review).",
    date: "a day ago",
    rating: 5,
    avatar: "A",
  },
  {
    name: "Bhagyashree Sonawane",
    text: "Edited review (recent).",
    date: "a day ago",
    rating: 5,
    avatar: "B",
  },
  {
    name: "Aziz Rajani",
    text: "(Recent short review.)",
    date: "1 month ago",
    rating: 5,
    avatar: "A",
  },
  {
    name: "K K INDUSTRIES",
    text: "(Business review.)",
    date: "1 month ago",
    rating: 5,
    avatar: "K",
  },
  // add more entries or slice for pagination as needed
];

const TestimonialsSection = () => {
  return (
    <Box py={16} px={4} bg="gray.50">
      <Container maxW="7xl" textAlign="center">
        <Heading
          as="h2"
          fontSize={{ base: "2xl", md: "3xl" }}
          fontWeight="bold"
          mb={8}
        >
          Client Testimonials
        </Heading>

        {/* Horizontal Scroll Container */}
        <Flex
          overflowX="auto"
          css={{
            "&::-webkit-scrollbar": {
              height: "8px",
            },
            "&::-webkit-scrollbar-thumb": {
              background: "#CBD5E0",
              borderRadius: "8px",
            },
          }}
        >
          <HStack spacing={6} pb={4}>
            {testimonials.map((item, idx) => (
              <Box
                key={idx}
                bg="white"
                p={6}
                borderRadius="md"
                boxShadow="md"
                minW={{ base: "280px", md: "350px" }}
                maxW="350px"
                minH="280px" // ✅ Ensure equal height for all cards
                display="flex"
                flexDirection="column"
                justifyContent="space-between"
                flexShrink={0} // ✅ Prevents shrinking
              >
                {/* Header: Avatar + Name + Google Icon */}
                <Flex justify="space-between" align="center" mb={4}>
                  <HStack spacing={3}>
                    {item.avatar.endsWith?.(".jpg") ? (
                      <Avatar src={item.avatar} name={item.name} />
                    ) : (
                      <Avatar name={item.avatar} />
                    )}
                    <Text fontWeight="bold">{item.name}</Text>
                  </HStack>
                  <Icon as={FaGoogle} color="red.500" boxSize={5} />
                </Flex>

                {/* Review Text */}
                <Text fontSize="sm" color="gray.700" mb={6} noOfLines={5}>
                  {item.text}
                </Text>

                {/* Footer: Stars + Date */}
                <Flex justify="space-between" align="center" mt="auto">
                  <HStack spacing={1}>
                    {Array.from({ length: item.rating }).map((_, i) => (
                      <Icon
                        key={i}
                        as={FaStar}
                        color="yellow.400"
                        boxSize={4}
                      />
                    ))}
                    {Array.from({ length: 5 - item.rating }).map((_, i) => (
                      <Icon key={i} as={FaStar} color="gray.300" boxSize={4} />
                    ))}
                  </HStack>
                  <Text fontSize="xs" color="gray.500">
                    {item.date}
                  </Text>
                </Flex>
              </Box>
            ))}
          </HStack>
        </Flex>
      </Container>
    </Box>
  );
};

export default TestimonialsSection;
